// extracted by mini-css-extract-plugin
export default {"loading":"events_loading__cF3Dt","excel-export":"events_excel-export__cSE5k"};